var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComputerDefault(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "3rmb3m5fza"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1486 0v1946H0V0h1486z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "apet4y35jb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 0c1.103 0 2 .897 2 2v14c0 1.103-.897 2-2 2h-7.001c.021.8.174 2.077.745 2.677.21.22.45.323.756.323a.5.5 0 1 1 0 1h-9a.5.5 0 1 1 0-1 .981.981 0 0 0 .756-.323c.57-.6.724-1.878.745-2.677H2c-1.103 0-2-.897-2-2V2C0 .897.897 0 2 0zm-8.004 18h-3.992c-.015.741-.132 2.074-.735 3h5.462c-.603-.926-.72-2.259-.735-3zM23 14H1v2c0 .551.449 1 1 1h20c.551 0 1-.449 1-1v-2zM22 1H2c-.551 0-1 .449-1 1v11h22V2c0-.551-.449-1-1-1z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2o34b0a3rc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3rmb3m5fza)",
    transform: "translate(-470 -496)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#apet4y35jb)",
    transform: "translate(470 497.767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v22H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2o34b0a3rc)",
    transform: "translate(481 512.267)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h2v2H0V0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputerDefault);
export default __webpack_public_path__ + "static/media/computer-default.489d3ead1c3c622aa80ba7aa0612991a.svg";
export { ForwardRef as ReactComponent };